<template>
  <div id="app">
    <!--
    <Cover v-if="showCover" class="coverAnimate" :class="{active:timeOut}"></Cover>-->
    <Tabbar v-if="showContent"></Tabbar>
    <router-view v-if="showContent"></router-view>
    <Footer v-if="showContent"></Footer>
  </div>
</template>

<script>
import Tabbar from "@/components/TabBar/tabbar.vue";
import Footer from "@/components/Footer/footer.vue";
// import Cover from "@/components/Cover";
export default {
  name: "App",
  components: {
    Tabbar,
    Footer,
    // Cover,
  },
  data() {
    return {
      isSecond: sessionStorage.getItem("isSecond"),
      // isSecond: false,
      showCover: false,
      timeOut: false,
      showContent: false
    };
  },
  created() {
    this.Api.EnterpriseConfigSearchApi({})
      .then(res => {
        let files = res.Data.files || [];
        let companyInfo = {};
        if (files.length > 0) {
          companyInfo = files[0]
          companyInfo.documentsIISHttp = res.Data.documentsIISHttp;
          this.companyInfo = companyInfo;
        }
        localStorage.setItem('companyInfo', JSON.stringify(companyInfo))
        document.title = companyInfo.name;
        this.showContent = true;
        // console.log(res)
      })
      .catch(err => {
        this.showContent = true;
        console.log(err)
      })
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.coverAnimate {
  transition: opacity 1s;
  opacity: 1;

  &.active {
    opacity: 0;
  }
}
</style>
